module.exports = __webpack_public_path__ + "img/register-three.9d5164cd.png";